var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 255,
    height: 182,
    viewBox: "0 0 255 182",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.659 50.1129L126.306 50.241C130.181 50.5101 134.082 46.0511 134.921 39.5548C135.759 33.0585 133.243 27.5616 129.317 27.1387L128.059 26.9978C124.146 26.575 120.359 31.2262 119.52 37.7225C118.682 44.0779 118.745 49.6901 122.659 50.1129Z",
    fill: "#33312D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.74 39.3114C131.541 32.8919 129.012 27.2925 125.098 26.7928C121.185 26.3059 117.373 31.1109 116.572 37.5303C115.772 43.9498 118.301 49.5492 122.214 50.0489C126.128 50.5358 129.952 45.7308 130.74 39.3114Z",
    fill: "#605D5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.055 36.7231L123.282 36.1849L124.209 29.5733C125.899 17.5801 117.602 6.36847 105.709 4.58743C94.0316 2.84482 83.1422 10.6481 80.9567 22.3594L79.432 30.4958L75.6836 29.7783L77.2084 21.6419C79.7877 7.90606 92.5449 -1.25542 106.268 0.78189C120.219 2.87045 129.965 16.0168 127.983 30.0986L127.055 36.7231Z",
    fill: "url(#paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.0229 181.462H32.2913C14.7565 181.462 0.5 167.085 0.5 149.403C0.5 140.844 3.80365 132.784 9.81376 126.736L10.9192 125.621C13.3969 123.123 17.4249 123.123 19.9026 125.621C22.3803 128.12 22.3803 132.182 19.9026 134.68L18.7844 135.808C15.1758 139.447 13.1936 144.278 13.1936 149.416C13.1936 160.025 21.7577 168.661 32.2786 168.661H65.0102C68.5171 168.661 71.3633 171.531 71.3633 175.068C71.3633 178.604 68.5298 181.462 65.0229 181.462Z",
    fill: "url(#paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.805 88.7577C124.031 71.3957 121.82 60.2994 122.9 45.2823C123.879 31.6618 125.696 21.9878 125.696 21.9878L114.082 29.1888C112.125 27.6384 107.78 25.2424 102.468 25.2424C97.1445 25.2424 92.6718 27.2156 92.6718 27.2156L84.832 17.0547C84.832 17.0547 74.1968 32.5844 74.057 49.8054C73.7775 68.4358 70.9821 80.7238 66.4967 93.2808C59.7751 112.052 43.8159 127.441 41.4398 140.844C38.5046 156.232 45.9251 177.964 60.8932 181.5C70.5119 181.5 122.417 181.5 131.439 181.5C139.558 180.513 152.29 159.474 143.751 134.36C139.978 123.341 132.837 111.053 127.805 88.7577Z",
    fill: "url(#paint2_radial)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4164 41.8227C95.7213 40.1314 94.743 38.5425 93.2309 38.2606C91.7062 37.9787 90.2322 39.1191 89.9146 40.7977C89.6096 42.489 90.588 44.0779 92.1 44.3597C93.6248 44.6416 95.1114 43.5013 95.4164 41.8227Z",
    fill: "#33312D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.8015 33.0585C87.602 26.639 85.2768 21.0653 81.3632 20.5656C79.8893 27.1259 73.4217 24.8452 72.6339 31.2646C72.0622 35.8774 74.7432 43.2963 74.7432 43.2963C74.7432 43.2963 77.1701 43.6422 78.2756 43.7832C82.1891 44.2829 86.001 39.4779 86.8015 33.0585Z",
    fill: "#605D5A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.492 45.6539C115.797 43.9626 114.819 42.3737 113.307 42.0918C111.782 41.8099 110.308 42.9503 109.99 44.6288C109.686 46.3202 110.664 47.909 112.176 48.1909C113.701 48.4728 115.175 47.3453 115.492 45.6539Z",
    fill: "#33312D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.588 57.4421C100.029 57.2884 99.635 56.5708 99.7874 56.007L100.791 50.5358C100.956 49.831 101.528 49.4338 102.227 49.4467C102.926 49.6132 103.32 50.1898 103.307 50.8945L102.303 56.3658C102.138 57.0705 101.566 57.4677 100.867 57.4549C100.588 57.4421 100.588 57.4421 100.588 57.4421Z",
    fill: "#33312D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.8344 47.6656C99.1648 46.128 100.842 46.4611 103.066 46.8071C104.908 47.1018 106.814 47.7681 106.357 49.1647C106.026 50.7023 103.599 52.6115 101.782 52.2784C99.8382 51.7914 98.3643 49.2032 98.8344 47.6656Z",
    fill: "#33312D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.624 172.8C103.129 173.364 99.9019 170.967 99.3428 167.431L86.1918 127.21C85.6327 123.687 94.5907 117.613 98.0849 117.049L98.2247 118.6C101.719 118.036 109.139 119.445 109.699 122.982L112.075 165.471C112.507 168.994 110.118 172.236 106.624 172.8Z",
    fill: "#72ACF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.453 172.659C131.947 171.954 134.196 168.571 133.497 165.176L132.519 122.687C131.82 119.164 121.464 116.614 117.957 117.177L118.377 118.587C114.883 119.292 108.301 123.11 109 126.493L120.893 167.29C121.744 170.967 125.098 173.364 128.453 172.659Z",
    fill: "#72ACF1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.3279 43.3731C79.2414 43.7959 83.0279 39.1447 83.8665 32.6484C84.7052 26.293 82.1893 20.6552 78.263 20.2324L77.0051 20.0914C73.0915 19.6686 69.3051 24.3198 68.4664 30.8161C67.6278 37.3124 70.1437 42.8093 74.0699 43.2322",
    fill: "#33312D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.636 172.889H223.103C228.033 172.889 232.416 169.737 234.017 165.047L254.284 105.85C255.123 103.313 253.306 100.622 250.51 100.622H155.047C152.811 100.622 150.842 102.032 150.143 104.146L126.636 172.889Z",
    fill: "#E1DFDD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.8791 181.5H227.69C229.646 181.5 231.324 179.95 231.324 177.835V176.426C231.324 174.453 229.786 172.761 227.69 172.761H93.8791C91.9224 172.761 90.2451 174.312 90.2451 176.426V177.835C90.2451 179.937 91.9224 181.5 93.8791 181.5Z",
    fill: "#C8C6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.636 172.889H132.659L155.619 105.838C157.131 101.981 155.2 100.61 155.2 100.61C152.964 100.61 150.994 102.019 150.295 104.134L126.636 172.889Z",
    fill: "#C8C6C4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.898 177.118C82.0619 177.118 70.7152 158.513 85.7976 141.471C100.88 124.43 102.329 103.083 100.372 90.6541C96.8775 68.2052 72.6338 66.8214 76.4076 43.5269",
    stroke: "#0078D4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.372 90.6541C100.372 72.7283 122.062 76.7901 123.599 50.1129",
    stroke: "#0078D4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.326 179.476L111.604 179.514C112.926 179.578 114.006 178.54 113.904 177.118C113.968 175.785 112.938 174.696 111.528 174.799L108.263 174.76C106.941 174.696 105.861 175.734 105.963 177.156C105.975 178.322 107.005 179.411 108.326 179.476Z",
    fill: "#33312D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 75.6854,
    y1: 18.6099,
    x2: 128.239,
    y2: 18.6099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00112968,
    stopColor: "#33312D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#605D5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 60.234,
    y1: 152.602,
    x2: 22.7425,
    y2: 152.602,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00138828,
    stopColor: "#3395E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72ACF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(120.268 179.739) scale(49.4375 49.8534)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00195993,
    stopColor: "#3395E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#72ACF1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 254,
    height: 181,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.5c6479190bb99edd6641428ef4568b47.svg";
export { ForwardRef as ReactComponent };